import { IonPage } from "@ionic/react";
import "./ProposalExternal.scss";
import { useEffect, useMemo, useState } from "react";
import { handleProposalExternal, Status } from "./ProposalExternalHandler";
import locales from "../../locales";
import { COOKIE_LANG } from "@france/superelements/utils";
import { getCookie } from "../../utils/security/cookies";
import LoadingPage from "../LoadingPage/LoadingPage";
import { ButtonHighlight } from "@france/superelements/lib";
import ROUTES from "../../router/constants/routes";

interface ProposalExternalProps {}

const ProposalExternal: React.FC<ProposalExternalProps> = () => {
  const [currentLang, _setCurrentLang] = useState(
    getCookie(COOKIE_LANG) || "es",
  );
  const [status, setStatus] = useState(Status.LOADING);

  const t = useMemo(() => {
    return (value: string) =>
      (locales as any)?.[currentLang as string]?.[value];
  }, [currentLang]);

  useEffect(() => {
    const fetchData = async () => {
      const status = await handleProposalExternal();
      setStatus(status);
    };
    fetchData();
  }, []);

  const handleGoHome = () => {
    window.location.href = ROUTES.BASIC_HOME;
  };

  if (!t) return <LoadingPage />;

  return (
    <IonPage id="ProposalExternal">
      <div className="container">
        <div className="text">{t(status)}</div>
        <ButtonHighlight name={t("go_home")} onClick={handleGoHome} />
      </div>
    </IonPage>
  );
};

export default ProposalExternal;
